<template>
<div class="ibox-child">
  <div class="row">
    <template v-if="view == 'Okr'">
      <div id="limited" class="date form-group col-sm-6">
        <label class="control-label">{{$t('startDateStr')}}</label>
        <div class="input-group date">
          <span class="input-group-addon"><i class="fa fa-calendar" @click="openStartPicker"></i></span>
          <datepicker :language="datepickerLocale[checkLanguage]" :format='format' :typeable='true' placeholder="Select Date" v-model="getStartDate" ref="startCalendarOpen"></datepicker>
          <span v-if="!getStartDate" class="text-danger font-bold">{{$t('noDayStr')}}</span>
        </div>
        <label class="control-label">{{$t('dueDateStr')}}</label>
        <div class="input-group date">
          <span class="input-group-addon"><i class="fa fa-calendar" @click="openDuePicker"></i></span>
          <datepicker :language="datepickerLocale[checkLanguage]" :format='format' :typeable='true' placeholder="Select Date" v-model="getDueDate" ref="dueCalendarOpen"></datepicker>
        </div>
        <span v-if="!getDueDate" class="text-danger font-bold">{{$t('noDayStr')}}</span>
        <span v-if="!this.alertDate" class="text-danger font-bold">{{$t('alertDateStr')}}</span>
      </div>
      <div class="form-group col-sm-6">
        <label class="control-label">{{$t('progressRateLabelTitle')}}</label>
        <div>
          <objective-knob :progress="getRate" @changeKnob="knobChange" :setReadOnly="'false'"></objective-knob>
        </div>
      </div>
    </template>
    <template v-else-if="view == '1on1'">
      <div id="limited" class="date form-group col-sm-12">
        <label class="control-label">{{$t('dateLabelTitle')}}</label>
        <div class="input-group date">
          <span class="input-group-addon"><i class="fa fa-calendar" @click="openDuePicker"></i></span>
          <datepicker :language="datepickerLocale[checkLanguage]" class="col-sm-10" :format='format' :typeable='true' placeholder="Select Date" v-model="getDueDate" ref="dueCalendarOpen"></datepicker>
          <span v-if="!getDueDate" class="text-danger font-bold">{{$t('noDayStr')}}</span>
        </div>
      </div>
    </template>
  </div>
</div>
</template>

<script>
import ObjectiveKnob from '@/components/Okr/ObjectiveKnob'
import { i18n } from '@/main.js'
import {ja, en, zh} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'RegistLimit',
  props: {
    tag: {
      type: String
    },
    view: {
      type: String
    },
    dueDate: {
      type: Date
    },
    startDate: {
      type: Date
    },
    progress: {
      type: String
    },
    alertDate: {
      type: Boolean
    }
  },
  computed: {
    checkLanguage () {
      return i18n.locale
    },
    getRate: function () {
      return Number.parseInt(this.progress)
    },
    getDueDate: {
      get: function () {
        return this.dueDate
      },
      set: function (value) {
        this.$parent.dueDate = value
        // this.dueDate = value
      }
    },
    getStartDate: {
      get: function () {
        return this.startDate
      },
      set: function (value) {
        this.$parent.startDate = value
      }
    }
  },
  components: {
    ObjectiveKnob,
    Datepicker
  },
  data: function () {
    return {
      format: 'yyyy/MM/dd',
      datepickerLocale: {
        ja: ja,
        en: en,
        zh_tr: zh
      }
    }
  },
  mutations: {
    updatedueDate (state, p) {
      state.obj.dueDate = p
    }
  },
  updated: function () {
    this.$parent.dueDate = this.getDueDate
    this.$parent.startDate = this.getStartDate
  },
  methods: {
    openDuePicker: function () {
      this.$refs.dueCalendarOpen.showCalendar()
    },
    openStartPicker: function () {
      this.$refs.startCalendarOpen.showCalendar()
    },
    updateProgressInfo: function (value) {
      this.$emit('set-progress', value)
    },
    knobChange (value) {
      this.$emit('set-progress', value)
    },
    send () {
      this.knobValue = 255
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Regist/RegistLimit.vue